/* Drawer upsell + AJAX cart helpers. Event delegation survives the drawer's
   section re-renders. The discount itself is Shopify's automatic BXGY. */
(function () {
  var busy = false;

  function refreshDrawer(state) {
    try {
      var sections = state && state.sections;
      if (!sections) return false;
      var drawerHtml = sections['cart-drawer'];
      var bubbleHtml = sections['cart-icon-bubble'];
      if (drawerHtml) {
        var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var next = doc.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (next && current) current.innerHTML = next.innerHTML;
        // Dawn hides the item rows whenever the outer element still carries
        // is-empty, so sync it from the freshly rendered section.
        var nextDrawer = doc.querySelector('cart-drawer');
        var curDrawer = document.querySelector('cart-drawer');
        if (nextDrawer && curDrawer) {
          curDrawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
        }
      }
      if (bubbleHtml) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var bdoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          var inner = bdoc.querySelector('.shopify-section') || bdoc.body;
          bubble.innerHTML = inner.innerHTML;
        }
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function track(action) {
    if (typeof gtag === 'function') {
      gtag('event', 'upsell_toggle', { location: 'drawer', action: action });
    }
  }

  document.addEventListener('change', function (e) {
    var check = e.target;
    if (!check.matches || !check.matches('[data-cart-bump-check]')) return;
    var box = check.closest('[data-cart-bump]');
    if (!box || busy) return;
    busy = true;
    check.disabled = true;
    track(check.checked ? 'on' : 'off');

    var id = parseInt(box.dataset.upsellId, 10);
    var req;
    var sections = 'cart-drawer,cart-icon-bubble';

    if (check.checked) {
      req = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections })
      });
    } else {
      // The discount can split this variant across several lines, and change.js
      // keyed by variant id misfires then. Find the last matching line and
      // decrement that line only.
      req = fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lineNo = -1;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].variant_id === id) lineNo = i + 1;
          }
          if (lineNo < 0) throw new Error('upsell line not found');
          var line = cart.items[lineNo - 1];
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineNo, quantity: Math.max(0, line.quantity - 1), sections: sections })
          });
        });
    }

    req
      .then(function (r) {
        if (!r.ok) throw new Error('cart request failed');
        return r.json();
      })
      .then(function (state) {
        busy = false;
        if (!refreshDrawer(state)) window.location.reload();
      })
      .catch(function () {
        busy = false;
        check.disabled = false;
        check.checked = !check.checked;
      });
  });

  // The overlay's own listener is bound once by Dawn and dies when we swap the
  // drawer's innerHTML, so close on overlay clicks via delegation instead.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'CartDrawer-Overlay') {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
    }
  });

  // Header cart links open the drawer instead of navigating when it exists.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (!link) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    e.preventDefault();
    drawer.open();
  });

  // Used by the simple buy box: add to cart via AJAX, then open the drawer.
  window.ffAddToCartAndOpenDrawer = function (variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity || 1 }],
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (state) {
        refreshDrawer(state);
        openDrawer();
        return state;
      });
  };
})();
